export default "__VITE_ASSET__DSNwmeTy__"